import { render, staticRenderFns } from "./WelfareSearchResult.vue?vue&type=template&id=1199f782&scoped=true"
import script from "./WelfareSearchResult.vue?vue&type=script&lang=js"
export * from "./WelfareSearchResult.vue?vue&type=script&lang=js"
import style0 from "./WelfareSearchResult.vue?vue&type=style&index=0&id=1199f782&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1199f782",
  null
  
)

export default component.exports